import React, { useContext, useState } from 'react'
import Popover from 'antd/lib/popover'
import useTranslation from '../hooks/useTranslation'
import ImageWithBasePath from './ImageWithBasePath'
import _JSXStyle from 'styled-jsx/style'
import { formattedUrl, seekersAnalayticOptions } from '../utils/functions'
import { trackEvent } from '../analytics'
import { clog } from '../utils/functions'
import { SharedContext } from '../context/SharedContext'

export const KebabMenu = ({ id, job }) => {
  const translation = useTranslation()
  const { setShowToast, utmParams, loginDetails, location } = useContext(SharedContext)
  const [placement, setPlacement] = useState('topLeft')
  const contentObject = [
    {
      title: translation.share,
      icon: 'shareIcon',
      height: 14.83,
      width: 18
    },
    {
      title: translation.shareOnWhatsApp,
      icon: 'whatsapp',
      height: 17.8,
      width: 18
    },
    {
      title: translation.report,
      icon: 'reportIcon',
      height: 24,
      width: 24
    }
  ]

  const whatsappShareHandler = () => {
    const url = encodeURIComponent(
      `${document.location.origin}/jobs/${formattedUrl(
        job.job_category,
        'category'
      )}-in-${formattedUrl(job?.translated_content?.primary_details?.Place)}-with-${formattedUrl(
        job?.translated_content?.primary_details?.Experience,
        'experience'
      )}-${job.id}`
    )
    window.open(`https://api.whatsapp.com/send?text=${url}`)
  }

  const shareHandler = async () => {
    if (navigator.share) {
      navigator
        .share({
          title: job?.translated_content?.title,
          text: job?.translated_content?.title + '\n\n' + 'Click the below link to apply the job\n',
          url: `${document.location.origin}/jobs/${formattedUrl(
            job.job_category,
            'category'
          )}-in-${formattedUrl(
            job?.translated_content?.primary_details?.Place
          )}-with-${formattedUrl(
            job?.translated_content?.primary_details?.Experience,
            'experience'
          )}-${job.id}`
        })
        .then(() => {
          clog('Successfully shared')
        })
        .catch((error) => {
          return `Something went wrong sharing the blog, ${error}`
        })
    }
  }

  const content = () => (
    <div className="py-[5px] px-[8px]">
      {contentObject.map((item, index) => (
        <div
          className="flex items-center py-[11px]"
          onClick={() => {
            if (item.title === translation.report) {
              trackEvent({
                name: 'seeker_job_reported',
                searchParams: {
                  ...utmParams
                },
                options: {
                  ...seekersAnalayticOptions(
                    window,
                    loginDetails,
                    location,
                    'tap',
                    'seeker_listings_page'
                  ),
                  Classified_id: id
                },
                isSeeker: true
              })
              setShowToast({ isVisible: true })
            }
            if (item.title === translation.share) {
              shareHandler()
              trackEvent({
                name: 'job_post_shared',
                searchParams: {
                  ...utmParams
                },
                options: {
                  ...seekersAnalayticOptions(
                    window,
                    loginDetails,
                    location,
                    'tap',
                    'seeker_listings_page'
                  ),
                  Classified_id: id,
                  source: 'normal share'
                },
                isSeeker: true
              })
            }
            if (item.title === translation.shareOnWhatsApp) {
              trackEvent({
                name: 'job_post_shared',
                searchParams: {
                  ...utmParams
                },
                options: {
                  ...seekersAnalayticOptions(
                    window,
                    loginDetails,
                    location,
                    'tap',
                    'seeker_listings_page'
                  ),
                  Classified_id: id,
                  source: 'share by whatsapp'
                },
                isSeeker: true
              })
              whatsappShareHandler()
            }
          }}
          key={index}
          id={item.title}
        >
          <div className="flex items-center">
            <div className=" mr-[7px] flex items-center">
              <ImageWithBasePath
                src={item.icon}
                height={item.height}
                width={item.width}
                alt="share symbol"
              />
            </div>
            <div className="text-[#66676B]">{item.title}</div>
          </div>
        </div>
      ))}
    </div>
  )

  return (
    <Popover
      placement={placement}
      title=""
      overlayClassName="w-[87%] rounded-[4px] bg-white p-[0px] shadow-default sm:w-[315px]"
      onClick={() => {
        let element = document?.getElementById?.(id)
        const top = element?.getBoundingClientRect()?.top
        if (top >= 200) {
          setPlacement('topLeft')
        } else {
          setPlacement('bottomLeft')
        }
      }}
      content={content}
      trigger="click"
      getPopupContainer={(trigger) => trigger.parentElement}
      showArrow={false}
    >
      <div
        className="flex w-fit items-center justify-center pl-[10px] pr-[18px]"
        id="kebab_menu_icon"
      >
        <ImageWithBasePath src="threeDotsIcon" height={16} width={4} alt="three dots symbol" />
      </div>
      <style jsx global>{`
        :where(.css-dev-only-do-not-override-1ij74fp).ant-popover .ant-popover-inner {
          padding: 0px;
        }
      `}</style>
    </Popover>
  )
}
